export default (partnerships) => partnerships && partnerships.filter((x) => x.prefix !== 'cvp' && x.prefix !== 'vff');
